module.exports = __webpack_public_path__ + "img/khalti.4d1bf692.png";